import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative space-y-6 lg:space-y-8 px-3 sm:px-4 lg:px-8 min-h-[calc(100vh-8rem)]" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "hidden sm:inline" }
const _hoisted_5 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 lg:gap-6"
}
const _hoisted_6 = {
  key: 0,
  class: "bg-red-50 text-red-600 p-4 rounded-xl border border-red-200"
}
const _hoisted_7 = {
  key: 1,
  class: "bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200/50 dark:border-slate-700/50 overflow-hidden"
}
const _hoisted_8 = { class: "hidden lg:block overflow-x-auto" }
const _hoisted_9 = { class: "min-w-full divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_10 = { class: "divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "px-6 py-4" }
const _hoisted_13 = { class: "flex items-center gap-3 justify-start" }
const _hoisted_14 = ["src", "alt", "onError"]
const _hoisted_15 = { class: "min-w-0 text-left" }
const _hoisted_16 = { class: "text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_17 = { class: "text-sm text-slate-500 dark:text-slate-400" }
const _hoisted_18 = { class: "px-6 py-4 text-sm font-medium text-slate-700 dark:text-slate-300" }
const _hoisted_19 = { class: "px-6 py-4 text-sm text-slate-500 dark:text-slate-400 whitespace-nowrap" }
const _hoisted_20 = { class: "px-6 py-4" }
const _hoisted_21 = { class: "px-6 py-4" }
const _hoisted_22 = { class: "flex gap-2 justify-center" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "lg:hidden divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_26 = {
  key: 0,
  class: "p-8 flex justify-center"
}
const _hoisted_27 = {
  key: 1,
  class: "px-6 py-12 text-center text-slate-500"
}
const _hoisted_28 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_29 = ["src", "alt", "onError"]
const _hoisted_30 = { class: "min-w-0 flex-1" }
const _hoisted_31 = { class: "text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_32 = { class: "text-xs text-slate-500 dark:text-slate-400 truncate" }
const _hoisted_33 = { class: "text-sm font-medium text-slate-700 dark:text-slate-300 mb-1" }
const _hoisted_34 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_35 = { class: "text-xs text-slate-500 dark:text-slate-400" }
const _hoisted_36 = { class: "flex gap-2" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 2,
  class: "card border border-gray-200/50 dark:border-gray-700/50 shadow-sm sticky bottom-0 z-30"
}
const _hoisted_40 = { class: "p-4" }
const _hoisted_41 = { class: "flex sm:items-center sm:justify-center min-h-screen sm:px-4 sm:pt-4 sm:pb-20 text-center" }
const _hoisted_42 = { class: "inline-block align-bottom sm:align-middle bg-white dark:bg-gray-800 sm:rounded-lg text-left overflow-hidden shadow-xl transform transition-all min-h-screen w-full fixed inset-x-0 top-0 sm:static sm:min-h-0 sm:max-w-4xl sm:w-full flex flex-col" }
const _hoisted_43 = { class: "bg-gradient-to-tr from-primary to-secondary dark:from-primary-light/10 dark:to-secondary-light/10 px-4 py-4 sm:px-6 flex items-center justify-between flex-shrink-0" }
const _hoisted_44 = { class: "text-lg font-bold text-white truncate" }
const _hoisted_45 = { class: "bg-white dark:bg-gray-800 px-3 pt-4 pb-3 sm:p-6 sm:pb-4 overflow-y-auto flex-1 max-h-[calc(100vh-12rem)]" }
const _hoisted_46 = { class: "text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 truncate" }
const _hoisted_47 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_48 = ["src"]
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  key: 1,
  class: "text-center py-8 text-slate-500 border border-dashed rounded-xl"
}
const _hoisted_51 = { class: "text-sm mt-1" }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = { class: "bg-gray-50 dark:bg-gray-700 px-4 py-3 flex flex-col gap-2 sm:px-6 sm:flex-row-reverse sm:gap-0 shrink-0" }
const _hoisted_54 = ["onClick"]

import { ref, computed, onMounted, watch } from 'vue'
import { Eye, EyeOff, FileText, Mail, Trash2, Printer, Download as DownloadIcon, X, Loader2 } from 'lucide-vue-next'
import { completedFormService, type CompletedForm } from '@/services/completedFormService'
import TableControls from '@/components/layout/TableControls.vue'
import PaginationBar from '@/components/layout/PaginationBar.vue'
import StatCard from '@/components/layout/StatCard.vue'
import TableLoader from '@/components/ui/TableLoader.vue'
import api from '@/services/api'
import { useToast } from 'vue-toastification'

const toastTimeout = 5000


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminCompletedFormsView',
  setup(__props) {

const toast = useToast()
const avatarLoadFailed = ref<Set<number>>(new Set())

const forms = ref<CompletedForm[]>([])
const loading = ref(false)
const error = ref('')
const showStats = ref(false)

const searchQuery = ref('')
const statusFilter = ref('')

const statusOptions = [
  { label: 'All', value: '' },
  { label: 'New', value: 'new' },
  { label: 'Read', value: 'read' },
  { label: 'Deleted', value: 'deleted' },
]

const showViewModal = ref(false)
const viewFormData = ref<CompletedForm | null>(null)

const viewFiles = computed(() => {
  if (viewFormData.value?.files && viewFormData.value.files.length > 0) {
    return viewFormData.value.files
  }
  if (viewFormData.value?.file_url) {
    return [{
      file_url: viewFormData.value.file_url,
      file_extension: viewFormData.value.file_extension || '',
      is_previewable: viewFormData.value.is_previewable || false,
    }]
  }
  return []
})

const stats = computed(() => {
  const all = forms.value
  return {
    total: all.length,
    new: all.filter(f => f.status === 'new').length,
    read: all.filter(f => f.status === 'read').length,
    deleted: all.filter(f => f.status === 'deleted').length,
  }
})

const statusFiltered = computed(() => {
  const list = forms.value
  if (!statusFilter.value) return list
  return list.filter(f => f.status === statusFilter.value)
})

const searchFiltered = computed(() => {
  const list = statusFiltered.value
  if (!searchQuery.value.trim()) return list
  const q = searchQuery.value.toLowerCase()
  return list.filter(f =>
    (f.form_subject || '').toLowerCase().includes(q)
  )
})

const perPage = ref(10)
const currentPage = ref(1)
const filteredTotalPages = computed(() => Math.max(1, Math.ceil(searchFiltered.value.length / perPage.value)))
const filteredTotal = computed(() => searchFiltered.value.length)

const paginatedForms = computed(() => {
  const start = (currentPage.value - 1) * perPage.value
  const end = start + perPage.value
  return searchFiltered.value.slice(start, end)
})

watch([statusFilter, searchQuery, perPage], () => {
  currentPage.value = 1
})

const goToPage = (page: number) => {
  currentPage.value = page
}

const formatDate = (date?: string) => {
  if (!date) return '—'
  const d = new Date(date)
  const opts: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
  return d.toLocaleDateString('en-US', opts) + ' [' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) + ']'
}

const submittedByName = (form: CompletedForm) => {
  const f = form.user?.details?.first_name || ''
  const l = form.user?.details?.last_name || ''
  if (f && l) return `${f} ${l}`
  return form.form_from || form.user?.email || 'Unknown'
}

const submittedByInitials = (form: CompletedForm) => {
  const f = form.user?.details?.first_name || ''
  const l = form.user?.details?.last_name || ''
  if (f && l) return (f[0] + l[0]).toUpperCase()
  const name = form.form_from || ''
  const parts = name.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  return name.substring(0, 2).toUpperCase() || '?'
}

const submittedByBgClass = (form: CompletedForm) => {
  const gradients = [
    'from-primary to-primary-hover dark:from-primary-dark dark:to-primary-dark-hover',
    'from-success to-success-hover dark:from-success-dark dark:to-success-dark-hover',
    'from-info to-info-hover dark:from-info-dark dark:to-info-dark-hover',
    'from-warning to-warning-hover dark:from-warning-dark dark:to-warning-dark-hover',
    'from-danger to-danger-hover dark:from-danger-dark dark:to-danger-dark-hover',
  ]
  return gradients[(form.user_id || 0) % gradients.length]
}

const profileImageUrl = (form: CompletedForm) => {
  const raw = String(form.user?.profile_picture || '').trim()
  if (!raw || raw.toLowerCase() === 'null') return ''
  if (/^https?:\/\//i.test(raw) || raw.startsWith('data:image/') || raw.startsWith('blob:')) return raw
  const rawBase = String(api.defaults.baseURL || '').replace(/\/$/, '')
  const baseNoApi = rawBase.replace(/\/api$/i, '')
  if (raw.startsWith('/storage/')) return `${baseNoApi}${raw}`
  if (raw.startsWith('storage/')) return `${baseNoApi}/${raw}`
  return `${baseNoApi}/storage/${raw.replace(/^\//, '')}`
}

const shouldShowProfileImage = (form: CompletedForm) => {
  const url = profileImageUrl(form)
  return Boolean(url) && !avatarLoadFailed.value.has(form.user_id || 0)
}

const onProfileImageError = (form: CompletedForm) => {
  avatarLoadFailed.value.add(form.user_id || 0)
}

const typeClass = (type?: string) => {
  switch (type) {
    case 'Doc File': return 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
    case 'Online form': return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
    case 'URL Link': return 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300'
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300'
  }
}

const viewForm = (form: CompletedForm) => {
  viewFormData.value = form
  showViewModal.value = true
}

const handleDownload = async (file: { download_url?: string; file_name?: string }) => {
  const url = file.download_url
  if (!url) return
  try {
    const token = localStorage.getItem('token')
    const response = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
    if (!response.ok) throw new Error('Download failed')
    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = file.file_name || 'download'
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(blobUrl)
    document.body.removeChild(a)
  } catch {
    // fallback: open in new tab
    if (file.download_url) {
      window.open(file.download_url, '_blank')
    }
  }
}

const printForm = async (form: CompletedForm | null) => {
  if (!form) return
  if (form.form_content) {
    const win = window.open('', '_blank')
    if (!win) return
    win.document.write('<html><head><title>' + (form.form_subject || 'Form') + '</title>')
    win.document.write('<style>body { padding: 20px; font-family: Arial, sans-serif; }</style>')
    win.document.write('</head><body>')
    win.document.write(form.form_content)
    win.document.write('</body></html>')
    win.document.close()
    win.print()
    toast.success('Document printed successfully', { timeout: toastTimeout })
  } else if (form.files?.length) {
    const loadingToast = toast.info('Preparing document for printing...', { timeout: false })
    let downloadUrl = form.files[0].download_url
    if (!downloadUrl) {
      downloadUrl = completedFormService.getDownloadUrl(form.form_id as any)
    }
    try {
      await completedFormService.printFile(downloadUrl)
      toast.dismiss(loadingToast)
      toast.success('Document printed successfully', { timeout: toastTimeout })
    } catch (err: any) {
      toast.dismiss(loadingToast)
      toast.error(err.message || 'Failed to print file', { timeout: toastTimeout })
    }
  }
}

const fetchForms = async () => {
  loading.value = true
  error.value = ''
  try {
    forms.value = await completedFormService.fetchAll()
  } catch (err: any) {
    error.value = 'Failed to load completed forms.'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchForms()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", null, [
        _createElementVNode("h1", { class: "text-2xl sm:text-3xl lg:text-4xl font-bold text-primary dark:text-secondary" }, " Completed Forms "),
        _createElementVNode("p", { class: "text-sm text-slate-500 dark:text-slate-200 mt-2" }, " View forms completed by employees. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showStats.value = !showStats.value)),
          class: "px-4 py-2 rounded-lg font-semibold transition border border-gray-300 dark:border-gray-600 text-slate-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-gray-700 inline-flex items-center justify-center w-full sm:w-auto"
        }, [
          (!showStats.value)
            ? (_openBlock(), _createBlock(_unref(Eye), {
                key: 0,
                class: "h-5 w-5 mr-2"
              }))
            : (_openBlock(), _createBlock(_unref(EyeOff), {
                key: 1,
                class: "h-5 w-5 mr-2"
              })),
          _createElementVNode("span", _hoisted_4, _toDisplayString(showStats.value ? 'Hide Stats' : 'Show Stats'), 1)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "stats" }, {
      default: _withCtx(() => [
        (showStats.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(StatCard, {
                label: "Total",
                value: stats.value.total,
                loading: loading.value,
                icon: _unref(FileText),
                color: "text-blue-600 dark:text-blue-400"
              }, null, 8, ["value", "loading", "icon"]),
              _createVNode(StatCard, {
                label: "New",
                value: stats.value.new,
                loading: loading.value,
                icon: _unref(Mail),
                color: "text-blue-600 dark:text-blue-400"
              }, null, 8, ["value", "loading", "icon"]),
              _createVNode(StatCard, {
                label: "Read",
                value: stats.value.read,
                loading: loading.value,
                icon: _unref(Eye),
                color: "text-emerald-600 dark:text-emerald-400"
              }, null, 8, ["value", "loading", "icon"]),
              _createVNode(StatCard, {
                label: "Deleted",
                value: stats.value.deleted,
                loading: loading.value,
                icon: _unref(Trash2),
                color: "text-rose-600 dark:text-rose-400"
              }, null, 8, ["value", "loading", "icon"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(TableControls, {
      search: searchQuery.value,
      "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
      status: statusFilter.value,
      "onUpdate:status": _cache[2] || (_cache[2] = ($event: any) => ((statusFilter).value = $event)),
      perPage: perPage.value,
      "onUpdate:perPage": _cache[3] || (_cache[3] = ($event: any) => ((perPage).value = $event)),
      options: statusOptions,
      filterLabel: "Status",
      placeholder: "Search by subject...",
      class: "md:sticky md:top-[80px]"
    }, null, 8, ["search", "status", "perPage"]),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "bg-slate-50 dark:bg-slate-800/50" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Submitted By"),
                  _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Form Name"),
                  _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Date Submitted"),
                  _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Type"),
                  _createElementVNode("th", { class: "px-6 py-4 text-center text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Action")
                ])
              ], -1)),
              _createElementVNode("tbody", _hoisted_10, [
                (loading.value)
                  ? (_openBlock(), _createBlock(TableLoader, {
                      key: 0,
                      colspan: 5,
                      title: "Fetching Forms"
                    }))
                  : (paginatedForms.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("td", {
                          colspan: "5",
                          class: "px-6 py-12 text-center text-slate-500"
                        }, "No completed forms found.", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedForms.value, (form) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: form.form_id,
                    class: "hover:bg-slate-50 dark:hover:bg-slate-800/50"
                  }, [
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (shouldShowProfileImage(form))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: profileImageUrl(form),
                              alt: `${submittedByName(form)} photo`,
                              class: "h-10 w-10 rounded-full object-cover shadow-md flex-shrink-0",
                              onError: ($event: any) => (onProfileImageError(form))
                            }, null, 40, _hoisted_14))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["h-10 w-10 rounded-full flex items-center justify-center text-white font-bold shadow-md bg-gradient-to-br flex-shrink-0", submittedByBgClass(form)])
                            }, _toDisplayString(submittedByInitials(form)), 3)),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(form.form_from || '—'), 1),
                          _createElementVNode("div", _hoisted_17, _toDisplayString(form.user?.email || ''), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(form.form_subject || '—'), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(formatDate(form.date_sent)), 1),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-2.5 py-1 text-xs font-semibold rounded-full", typeClass(form.type)])
                      }, _toDisplayString(form.type || '—'), 3)
                    ]),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (viewForm(form)),
                          class: "p-2 text-primary hover:bg-primary/10 rounded-lg transition-colors",
                          title: "View"
                        }, [
                          _createVNode(_unref(Eye), { class: "w-5 h-5 text-blue-600" })
                        ], 8, _hoisted_23),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (printForm(form)),
                          class: "p-2 text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors",
                          title: "Print"
                        }, [
                          _createVNode(_unref(Printer), { class: "w-5 h-5" })
                        ], 8, _hoisted_24)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_unref(Loader2), { class: "w-8 h-8 animate-spin text-primary" })
                ]))
              : (paginatedForms.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, "No completed forms found."))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(paginatedForms.value, (form) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: form.form_id,
                      class: "p-4 hover:bg-slate-50 dark:hover:bg-slate-800/50"
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        (shouldShowProfileImage(form))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: profileImageUrl(form),
                              alt: `${submittedByName(form)} photo`,
                              class: "h-10 w-10 rounded-full object-cover shadow-md flex-shrink-0",
                              onError: ($event: any) => (onProfileImageError(form))
                            }, null, 40, _hoisted_29))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["h-10 w-10 rounded-full flex items-center justify-center text-white font-bold shadow-md bg-gradient-to-br flex-shrink-0", submittedByBgClass(form)])
                            }, _toDisplayString(submittedByInitials(form)), 3)),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(form.form_from || '—'), 1),
                          _createElementVNode("div", _hoisted_32, _toDisplayString(form.user?.email || ''), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, _toDisplayString(form.form_subject || '—'), 1),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2 py-1 text-xs font-semibold rounded-full", typeClass(form.type)])
                        }, _toDisplayString(form.type || '—'), 3),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(formatDate(form.date_sent)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (viewForm(form)),
                          class: "p-2 text-primary hover:bg-primary/10 rounded-lg transition-colors",
                          title: "View"
                        }, [
                          _createVNode(_unref(Eye), { class: "w-5 h-5 text-blue-600" })
                        ], 8, _hoisted_37),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (printForm(form)),
                          class: "p-2 text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors",
                          title: "Print"
                        }, [
                          _createVNode(_unref(Printer), { class: "w-5 h-5" })
                        ], 8, _hoisted_38)
                      ])
                    ]))
                  }), 128))
          ])
        ])),
    (!loading.value && !error.value && filteredTotal.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(PaginationBar, {
              "current-page": currentPage.value,
              "total-pages": filteredTotalPages.value,
              total: filteredTotal.value,
              "per-page": perPage.value,
              "onUpdate:page": goToPage
            }, null, 8, ["current-page", "total-pages", "total", "per-page"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showViewModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (showViewModal.value = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  class: "fixed inset-0 transition-opacity bg-black bg-opacity-50 dark:bg-opacity-50",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showViewModal.value = false))
                }),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("h3", _hoisted_44, _toDisplayString(viewFormData.value?.form_subject || 'Form Content'), 1),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showViewModal.value = false)),
                      class: "shrink-0 p-1.5 rounded-lg hover:bg-white/10 text-white/80 hover:text-white transition-colors"
                    }, [
                      _createVNode(_unref(X), { class: "h-5 w-5" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    (viewFiles.value.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(viewFiles.value, (file, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "mb-5 last:mb-0"
                          }, [
                            _createElementVNode("p", _hoisted_46, _toDisplayString(file.file_name || `File ${i + 1}`), 1),
                            (file.is_previewable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  (['jpg','jpeg','png','gif','webp'].includes(file.file_extension))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: file.file_url,
                                        class: "max-w-full max-h-[70vh] rounded-lg"
                                      }, null, 8, _hoisted_48))
                                    : (file.file_extension === 'pdf')
                                      ? (_openBlock(), _createElementBlock("iframe", {
                                          key: 1,
                                          src: file.file_url,
                                          class: "w-full h-[70vh] rounded-lg"
                                        }, null, 8, _hoisted_49))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  _createVNode(_unref(FileText), { class: "h-12 w-12 mx-auto mb-2 text-slate-300 dark:text-slate-600" }),
                                  _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-base font-medium" }, "Preview not available", -1)),
                                  _createElementVNode("p", _hoisted_51, "(." + _toDisplayString(file.file_extension) + ")", 1)
                                ]))
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "form-content",
                          innerHTML: viewFormData.value?.form_content || 'No content available.'
                        }, null, 8, _hoisted_52))
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewFiles.value, (file, i) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: i,
                        onClick: ($event: any) => (handleDownload(file)),
                        class: "w-full sm:w-auto sm:ml-3 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-primary hover:bg-secondary shadow-sm transition-all inline-flex items-center justify-center gap-2"
                      }, [
                        _createVNode(_unref(DownloadIcon), { class: "h-4 w-4" }),
                        _createTextVNode(" Download File " + _toDisplayString(viewFiles.value.length > 1 ? i + 1 : ''), 1)
                      ], 8, _hoisted_54))
                    }), 128)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full sm:w-auto px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-secondary-text dark:text-secondary-dark-text hover:bg-gray-100/80 dark:hover:bg-gray-700/60 transition-colors",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (showViewModal.value = false))
                    }, "Close")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})